export default __webpack_public_path__ + "static/media/vertical-logo.4224f7e8.png";